<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from '@/composables/useToast'
import {
  DISTRIBUTE_CARD_DEFAULT_AUTHOR,
  DISTRIBUTE_CARD_DEFAULT_TITLE,
  DISTRIBUTE_UNSUPPORTED_MESSAGE,
} from '@/constants/distribute'
import { formatFeedCardTitle } from '@/utils/distribute/format'
import { buildUserUrl } from '@/utils/distribute/navigation'
import type { Props } from './type'

defineOptions({
  name: 'DistributeCardChrome',
})

const props = defineProps<Props>()

const router = useRouter()
const toast = useToast()

const title = computed(() => formatFeedCardTitle(props.model.item, DISTRIBUTE_CARD_DEFAULT_TITLE))
const author = computed(() => props.model.item.user?.nickname || DISTRIBUTE_CARD_DEFAULT_AUTHOR)

function openAuthor() {
  const url = buildUserUrl(props.model.item.user)

  if (!url) {
    toast.info(DISTRIBUTE_UNSUPPORTED_MESSAGE)
    return
  }

  void router.push(url)
}
</script>

<template>
  <div class="card-chrome">
    <span class="card-chrome__title">{{ title }}</span>
    <button type="button" class="card-chrome__author" @click.stop="openAuthor">
      @{{ author }}
    </button>
  </div>
</template>

<style scoped>
.card-chrome {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  text-align: left;
}

.card-chrome__title {
  display: -webkit-box;
  overflow: hidden;
  color: var(--distribute-text-main);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.card-chrome__author {
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  padding: 0;
  border: 0;
  border-radius: 6px;
  appearance: none;
  background: transparent;
  color: var(--distribute-text-muted);
  font: inherit;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  transition:
    color 0.16s ease,
    opacity 0.16s ease;
}

.card-chrome__author:hover,
.card-chrome__author:focus-visible {
  color: var(--distribute-text-soft);
}

.card-chrome__author:active {
  opacity: 0.72;
}
</style>
